// import lazyLoading from '../lazyLoading';

export default {
  name: 'howto',
  caption: 'How to',
  wdm16_id: '',
  icon: 'icon-support',
  path: '/howto',
  // component: lazyLoading('patient/index'),
  required: [],
  permissions: [],
  meta: {
    required: [],
    icon: 'fa-bars',
    expanded: false
  }
};
